import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon } from 'lucide-react';
const names = ['Martín', 'Laura', 'Nicolás', 'Carolina', 'Diego', 'Valentina', 'Fernando', 'Lucía', 'Sebastián', 'María José', 'Alejandro', 'Camila', 'Pablo', 'Andrea', 'Gonzalo'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    const triggerPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentName(randomName);
      setCurrentCity(randomCity);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(triggerPopup, 3000);
    // Then trigger every 8-12 seconds
    const interval = setInterval(() => {
      triggerPopup();
    }, Math.floor(Math.random() * (12000 - 8000 + 1) + 8000));
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-social-proof" data-id="element-352">
      <div className="bg-white rounded-lg shadow-xl border-l-4 border-green-500 p-4 flex items-center gap-4 max-w-xs sm:max-w-sm" data-id="element-353">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-354">
          <ShoppingBagIcon className="w-6 h-6 text-green-600" data-id="element-355" />
        </div>
        <div data-id="element-356">
          <p className="text-sm text-gray-800 font-medium" data-id="element-357">
            <span className="font-bold" data-id="element-358">{currentName}</span> de {currentCity}{' '}
            acaba de comprar este producto
          </p>
          <p className="text-xs text-gray-500 mt-1" data-id="element-359">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}